<template>
	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link :to="{ name: 'bizregion', params: {dictionaryId: dictCode, page: page} }"
									 id="buttonback">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к списку Бизнес-Регионов
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">

						<div class="name">
							<h3 class="title">Редактирование элемента справочника Бизнес-Регионов</h3>
							<div class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep" v-if="selectedDataId">
								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field>
										<label>{{mapElementName['name']}}</label>
										<md-input type="text" v-model="form['name']"/>
									</md-field>
								</div>
							</div>
							<br/>
							<div class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep">

								<template v-if="selectedDataId">
									<md-button @click="validateData(saveItem)"
											   class="md-button md-success md-theme-default"
											   v-if="action !== 'delete'">
										Сохранить
									</md-button>

									<md-button @click="validateData(deleteItem)"
											   class="md-button md-primary  md-theme-default"
											   v-if="action === 'delete'">
										Удалить
									</md-button>

								</template>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
    import {
        required,
    } from 'vuelidate/lib/validators'
    import { saveItem, getItem, deleteItem, saveNewItem, deleteNewItem } from '@/utils/dict-api'
	import {appConfig} from '../../utils/config-api'

    export default {
        mixins: [
            validationMixin,
        ],
        bodyClass: 'dictionary-data',
        props: ['page', 'action'],
        data () {
            return {
                options: [],
                dictCode: this.$route.params.dictCode,
                dictionaryId: '',
                selectedDataId: this.$route.params.id,
                selectedData: null,
                form: {
                	id: this.$route.params.id,
                	name: '',
                },
                mapElementName: {
                	name: 'Название',
                    locOrder: 'Порядок отображения',
                    city: 'Город',
                    phone: 'Телефон',
                    country: 'Страна',
                    countryCode: 'Код страны',
                    fedSub: 'Федеральный субъект',
                    fedSubCode: 'Код фед субъекта',
                    cityCode: 'Код города',
                },
                cities: [],
                citiesObj: [],
            }
        },
        validations: {
            form: {
            	id: {
					required,
				},
				name: {
					required,
				},
            },
        },
        methods: {
            setCities () {
                if (this.form.city.length > 1) {
                    fetch(`${appConfig.backendUrl}/rest/geo/getcitybyname?cityName=${this.form.city}`)
                      .then(response => {
                          return response.json()
                      })
                      .then(responseJson => {
                          this.citiesObj = responseJson
                          this.cities = []
                          responseJson.forEach(item => {
                              this.cities.push(item.city)
                          })
                      })
                } else {
                    return []
                }
            },
            setCity (city) {
                let cityData = this.citiesObj.find(item => item.city === city)
                this.form.country = cityData.country
                this.form.countryCode = cityData.countryCode
                this.form.fedSub = cityData.fedSub
                this.form.fedSubCode = cityData.fedSubCode
                this.form.cityCode = cityData.cityCode
            },
            getValidationClass (fieldName) {
                const field = this.$v.form[fieldName]
                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty,
                    }
                }
            },
            validateData (sendFn) {
                this.$v.form.$touch()
                if (!this.$v.form.$invalid) {
                    sendFn()
                }
            },
            setData: function (data) {
                this.form = data
            },
            getElementData: function () {
                if (this.selectedDataId === 'new') {
                    this.addItem()
                    return
                }
                checkAuthentication(this.$router, this.$route).then(response => {
                    getItem('bizregion', this.selectedDataId).then(result => {
                        this.setData(result)
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            addItem: function () {
                const item = {
                    id: 'new',
                    name: '',
                }
                this.setData(item)

            },
            saveItem: function () {
                if (this.form.id === 'new') {
                    this.form.id = null
                }
                checkAuthentication(this.$router, this.$route).then(response => {
					saveNewItem('bizregion', JSON.stringify(this.form)).then(result => {
                        this.$router.push({ name: 'bizregion' })
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            deleteItem: function () {
                checkAuthentication(this.$router, this.$route).then(response => {
					deleteNewItem('bizregion', JSON.stringify(this.form)).then(result => {
                        this.$router.push({ name: 'bizregion' })

                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            checkEditableNames: function (name) {
                const editableNames = ['valueId', 'value', 'order']
                return (editableNames.indexOf(name) >= 0)
            },
        },
        created () {
            if (this.$route.params.action === 'delete') {
                this.deleteItem()
            } else {
                this.getElementData()
            }
        },
    }
</script>

<style lang="scss" scoped type="text/scss">
	.dictionary-data .md-field {
		padding-top: 16px;
		margin: 4px 0 24px;
	}

	.offset-left-16 {
		margin-left: 16px;
	}
</style>
